import styled, { css } from 'styled-components';

const activeColor = (color?) => color || '#BCD0F9';
const passedColor = (color?) => color.blue;

export const Stepper = styled.div`
  display: flex;
  width: 496px;
  height: ${({ theme }) => theme.spacing.x10};
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.rounded.x4};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
`;

export const StepperStep = styled.div<{ $active: boolean; $passed: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fs.xxs};
  position: relative;
  &::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 20px inset transparent;
    border-bottom: 20px inset transparent;
    border-left: 15px solid ${activeColor()};
    position: absolute;
    content: '';
    top: 0;
    left: 0;
  }

  &::after {
    content: '';
    width: 0;
    height: 0;
    border-top: 20px inset transparent;
    border-bottom: 20px inset transparent;
    border-left: 15px solid ${({ theme }) => theme.palette.white};
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    right: -14px;
    z-index: 2;
  }
  ${({ $active }) =>
    $active
      ? css`
          background: ${activeColor()};

          &::before {
            display: none;
            border: none;
          }

          &::after {
            border-left-color: ${activeColor()};
            right: -15px;
          }
        `
      : null}

  ${({ $passed }) =>
    $passed
      ? css`
          background: ${passedColor()};

          &::before {
            display: none;
            border: none;
          }

          &::after {
            border-left-color: ${passedColor()};
            right: -15px;
          }
        `
      : null}
`;
export const StepperStepSpan = styled.div`
  margin-inline-start: ${({ theme }) => theme.spacing.x4};
`;
